<template>
  <BaseDialog
    title="Customer Stop's Sequence"
    v-model="showCustomerSequence"
    width="50%"
    cardTextClass="px-4 pt-4"
  >
    <template #information>
      <v-row col="12" style="display: block">
        <ListLayout
          :gridStyle="{ height: '45vh', 'overflow-y': 'auto' }"
          :context="context"
          :hasAfterTitle="false"
          :hasFilter="false"
          :isColumnShowVisibility="false"
          :tableData="tableData"
          :total="totalItems"
          :tableHeader="tableHeader"
          :noMargin="true"
        >
        </ListLayout>
      </v-row>
    </template>
  </BaseDialog>
</template>
    
    <script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import { bus } from "@/main";
export default {
  components: {
    BaseDialog,
    ListLayout,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    tripId: {
      required: true,
    },
  },
  data() {
    return {
      tableHeader: [
        {
          headerName: "Trip Stops Sequence",
          field: "customer_sequence",
          sortable: false,
          resizable: false,
        },
        {
          headerName: "Name",
          field: "name",
          sortable: false,
          resizable: false,
        },
        {
          headerName: "Location Type",
          field: "stop_type",
          sortable: false,
          resizable: false,
        },
        {
          headerName: "Address",
          field: "address",
          sortable: false,
          resizable: false,
        },
      ],
      tableData: [],
      totalItems: 0,
    };
  },
  computed: {
    showCustomerSequence: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    context() {
      return { parentComponent: this };
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.fetchCustomerSequence();
      }
    },
  },
  methods: {
    fetchCustomerSequence() {
      bus.$emit("showLoader", true);
      this.$api.trip
        .getTripStops(this.tripId)
        .then((res) => {   
          this.tableData = res.data.filter(
            (dict) => Object.keys(dict).length !== 0
          );
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          if (err.data) {
            this.formErrors = err.data;
          }
          bus.$emit("showLoader", false);
        });
    },
    reset(){
      this.tableData = []
    }
  },
};
</script>
    
    <style></style>